export const PRODUCTS_LISTING_PLP_MENU = {
  MASONEILAN: 'ECOM_LVL1_00000017_disabled',
  CONSOLIDATED: 'ECOM_LVL1_00000018_disabled',
  BECKER: 'ECOM_LVL1_00000019_disabled',
  MOONEY: 'ECOM_LVL1_00000020_disabled'
};

export const PLP_MENU_NAMES = ['MASONEILAN', 'CONSOLIDATED', 'BECKER', 'MOONEY'];
